#!/usr/bin/env node
import { startMcpServer } from './index.js';

await startMcpServer();
